import { confetti as fireConfetti, type ConfettiConfig } from "dom-confetti"
import { useCallback, useRef } from "react"

export const defaultConfettiConfig = {
  colors: [
    "var(--logo-purple, #8E44EC)",
    "var(--logo-blue, #E8C7FF)",
    "var(--logo-yellow, #59B5F8)",
    "var(--logo-red, #C3EEFE)",
  ],
  elementCount: 300,
  width: "8px",
  height: "8px",
  stagger: 0.2,
  startVelocity: 35,
  spread: 90,
  duration: 3000,
} satisfies Partial<ConfettiConfig>

type UseConfettiProps = {
  config?: ConfettiConfig
  onAnimationEnd?: () => void
}

export function useConfetti(props?: UseConfettiProps) {
  const { config: overrideConfig, onAnimationEnd } = props ?? {}

  const confettiCannonRef = useRef<HTMLDivElement>(null)
  const confettiContainerRef = useRef<HTMLDivElement>(null)

  const throwConfetti = useCallback(() => {
    const confettiCannon = confettiCannonRef.current
    const confettiContainer = confettiContainerRef.current
    const config = { ...defaultConfettiConfig, ...overrideConfig }

    if (confettiCannon) {
      if (confettiContainer || onAnimationEnd) {
        const previousOverflow =
          confettiContainer && confettiContainer.style.overflow
        if (confettiContainer) confettiContainer.style.overflow = "hidden"

        setTimeout(() => {
          if (confettiContainer && previousOverflow) {
            confettiContainer.style.overflow = previousOverflow
          }
          onAnimationEnd?.()
        }, config.duration)
      }

      fireConfetti(confettiCannon, config)
    }
  }, [overrideConfig]) // eslint-disable-line react-hooks/exhaustive-deps -- onAnimationEnd should be pure

  return {
    throwConfetti,
    confettiCannonRef,
    confettiContainerRef,
  }
}
